import $ from 'jquery';

// Handles BHCC Config UI initialization for both licensee and state contexts.
// The #bhcc_config_ui element carries all required config as data-* attributes.
$(document).ready(function() {
  const uiContainer = document.getElementById('bhcc_config_ui');
  if (!uiContainer) return;

  const d = uiContainer.dataset;

  if (window.initGatewayBhccConfigUI) {
    const config = {
      aud: "gateway",
      context: d.context,
      email: d.email,
      auth_token: d.authToken,
      host: d.host,
    };

    if (d.stateCode)   config.state_code   = d.stateCode;
    if (d.licenseeId)  config.licensee_id  = d.licenseeId;

    window.initGatewayBhccConfigUI(uiContainer, config).catch(function(e) {
      const container = document.createElement('div');
      container.className = 'jumbotron';

      const heading = document.createElement('h2');
      heading.textContent = 'Error initiating bhcc_config_ui assets.';
      container.appendChild(heading);

      e.stack.split('\n').forEach(function(line) {
        const p = document.createElement('p');
        p.style.cssText = 'overflow-wrap: break-word; font-size: 12px';
        p.textContent = '¶  ' + line;
        container.appendChild(p);
      });

      uiContainer.innerHTML = '';
      uiContainer.appendChild(container);
    });
  } else {
    uiContainer.innerHTML =
      "<div class='jumbotron'>" +
      "<h2>Error</h2>" +
      "<p>There was an error retrieving the BHCC Configuration assets.</p>" +
      "<p>Please check the logs for errors and/or network connect errors.</p>" +
      "</div>";
  }
});
